export const clickToDialPhoneNumberRegExp = /calling:([^]+)/;
